import React from "react";

import { Chip } from "@mui/material";
import clsx from "clsx";
import mainStyles from "styles";

interface ActiveStatusChipProps {
  active: boolean | undefined;
}

const ActiveStatusChip = ({ active }: ActiveStatusChipProps) => {
  const classes = mainStyles();

  if (active === undefined) {
    return <></>;
  }

  return (
    <>
      <Chip
        size="small"
        color={active ? "success" : "default"}
        className={clsx(classes.spaceRightXSmall)}
        style={{
          fontWeight: "bold",
          marginBottom: "3px",
          color: `${active ? "white" : "black"}`,
        }}
        label={`${active ? "Active" : "Deactivated"}`}
        data-testid="active-status-chip"
      />
    </>
  );
};

export default ActiveStatusChip;
